import React from "react";
import { EditProfileLoader } from "../../components/common/loader";
import MandatoryLabel from "../../components/common/label";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { InputErrorMessage } from "../../components/errorMessages";
import FPHeader from "./FPHeader";
import { commonUsedClass } from "../Account/MobileLoginTalwind";

export default function FPPage_3({ formik3, passwordType, loader, setLoader, handelPasswordType, confirmPasswordType,
    handelConfirmPasswordType, BacktoSignin }) {
    const handleChange3 = (e) => {
        e.preventDefault();
        formik3.handleChange(e);
    };
    return (
        <div>
            <FPHeader
                Title={'Reset password'}
                TitleDescription={'Set the new password for your account so you can login and access all the features.'}
                BacktoSignin={() => { BacktoSignin() }}
            />

            <form className="resetpassword" onSubmit={formik3.handleSubmit} >
                <div className="my-2 py-2 space-y-4" >
                    <div className="newPasswordField" >
                        <MandatoryLabel title="New Password" />
                        <div className="relative" >
                            <input
                                type={passwordType}
                                name="newpassword"
                                className={
                                    Boolean(formik3.touched.newpassword) &&
                                        Boolean(formik3.errors.newpassword)
                                        ? commonUsedClass.inpNormal
                                        : commonUsedClass.inpErr
                                }
                                id="newpassword"
                                placeholder="New Password "
                                value={formik3.values.newpassword}
                                onChange={handleChange3}
                            />
                            <div
                                className="absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer"
                                onClick={handelPasswordType}
                            >
                                {passwordType == 'password' ? (
                                    <IoEyeOff />
                                ) : passwordType == 'text' ? (
                                    <IoEye />
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        {
                            (formik3.touched.newpassword && formik3.errors.newpassword) &&
                            < InputErrorMessage
                                error={formik3.touched.newpassword && formik3.errors.newpassword}
                            />
                        }

                    </div>
                    < div className="confirmPasswordField" >
                        <MandatoryLabel title="Confirm Password" />
                        <div className="relative" >
                            <input
                                type={confirmPasswordType}
                                name="confirmpassword"
                                className={
                                    Boolean(formik3.touched.confirmpassword) &&
                                        Boolean(formik3.errors.confirmpassword)
                                        ? commonUsedClass.inpNormal
                                        : commonUsedClass.inpErr
                                }
                                id="confirmpassword"
                                placeholder="Confirm Password "
                                value={formik3.values.confirmpassword}
                                onChange={handleChange3}
                            />
                            <div
                                className="absolute top-1/2 -translate-y-1/2 right-4 p-2 cursor-pointer"
                                onClick={handelConfirmPasswordType}
                            >
                                {confirmPasswordType == 'password' ? (
                                    <IoEyeOff />
                                ) : confirmPasswordType == 'text' ? (
                                    <IoEye />
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        {
                            (formik3.touched.confirmpassword && formik3.errors.confirmpassword) &&
                            < InputErrorMessage
                                error={
                                    formik3.touched.confirmpassword && formik3.errors.confirmpassword
                                }
                            />
                        }

                    </div>
                </div>
                < div className="modelFooter" >
                    <div className="mt-4" >
                        <button
                            className={commonUsedClass.btncon}
                            type="submit"
                        >
                            {!loader ? (
                                'Update Password'
                            ) : (
                                <div className="text-xs" >
                                    <EditProfileLoader />
                                </div>
                            )}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}